module.exports = __webpack_public_path__ + "img/vi-bg-fore.60de18c7.jpg";